// extracted by mini-css-extract-plugin
export default {"large":"Checkbox_large__PwBK3"};